/*
 * use-counter
 */
import { useState } from "react"

export interface UseCounterReturn {
	count: number
	increment: () => void
	reset: () => void
}

export function useCounter(start = 0): UseCounterReturn {
	const [count, setCount] = useState(start)

	function increment() {
		setCount(count + 1)
	}

	function reset() {
		setCount(start)
	}

	return { count, increment, reset }
}
